import { TextField, Typography } from "@mui/material"
import Proptypes from "prop-types";
import { DEFAULT_DATE_FORMAT } from "../../../../../ui/utils/dateFormat";

export const ModalDate = ({elementRef, value, setValue, dateFormat}) => {
    const fmt = dateFormat || DEFAULT_DATE_FORMAT;
    return (
        <>
            <TextField
                ref={elementRef}
                onChange={({target}) => setValue(target.value)}
                required
                type="date"
                name="date"
                margin="normal"
                fullWidth
                color="primary"
                placeholder="Fecha"
                defaultValue={value}
            />
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                La fecha se guardará con el formato: <strong>{fmt}</strong>
            </Typography>
            <br />
        </>

    )
}

ModalDate.propTypes = {
    elementRef: Proptypes.object,
    value: Proptypes.string,
    setValue: Proptypes.func,
    dateFormat: Proptypes.string,
}